/** CNPJ com dígitos verificadores (módulo 11). Aceita com ou sem pontuação. */
export function isValidCnpj(raw) {
    const d = raw.replace(/\D/g, '');
    if (d.length !== 14 || /^(\d)\1{13}$/.test(d))
        return false;
    const calc = (len) => {
        const weights = len === 12 ? [5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2] : [6, 5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2];
        const sum = weights.reduce((acc, w, i) => acc + Number(d[i]) * w, 0);
        const r = sum % 11;
        return r < 2 ? 0 : 11 - r;
    };
    return calc(12) === Number(d[12]) && calc(13) === Number(d[13]);
}
export function formatCnpj(raw) {
    const d = raw.replace(/\D/g, '').slice(0, 14);
    return d
        .replace(/^(\d{2})(\d)/, '$1.$2')
        .replace(/^(\d{2})\.(\d{3})(\d)/, '$1.$2.$3')
        .replace(/\.(\d{3})(\d)/, '.$1/$2')
        .replace(/(\d{4})(\d)/, '$1-$2');
}
/** Completa os 2 dígitos verificadores de uma base de 12 dígitos (útil em testes e seeds). */
export function withCnpjCheckDigits(base12) {
    const d = base12.replace(/\D/g, '').padStart(12, '0').slice(0, 12);
    const dv = (s, weights) => {
        const r = weights.reduce((acc, w, i) => acc + Number(s[i]) * w, 0) % 11;
        return r < 2 ? 0 : 11 - r;
    };
    const d1 = dv(d, [5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2]);
    const d2 = dv(`${d}${d1}`, [6, 5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2]);
    return `${d}${d1}${d2}`;
}
//# sourceMappingURL=cnpj.js.map